<!--课时资源-->
<template>
    <a-card>
        <a-table style="min-width: 800px;"
                 :columns="columns"
                 :rowKey="text => text.id"
                 :pagination="tableRelevant.tablePagination"
                 :loading="tableRelevant.tableLoading"
                 :locale="tableRelevant.locale"
                 :dataSource="tableRelevant.tableDataSource">
            <span slot="name" slot-scope="text">{{text.name}}</span>
            <span slot="versionName" slot-scope="text">{{text.versionName}}</span>
            <div slot="classifyTag" slot-scope="text">
                <span style="color: green" v-if="text.classifyTag == 1">商用</span>
                <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
                <span v-else>--</span>
            </div>
            <span slot="contentType" slot-scope="text">{{$data._contentType[text.contentType]}}</span>
            <div slot="abilityTypeName" slot-scope="text">
                <div class="self_td" v-for="item in text.contentAbilitys" :key="item.id">
                    <span v-if="text.contentType != 4">
                        {{item.abilityTypeName}}-
                        {{item.firstAbilityName}}-
                        {{item.secondAbilityName}}
                    </span>
                    <span v-else>
                        {{item.firstAbilityName}}
                    </span>
                </div>
            </div>
            <div slot="estimatedTime" slot-scope="text,record">
                <div v-if="text.contentType == 3 || text.contentType == 5">
                    <span v-if="record.finishType == 2">{{EstimatedTime(record.estimatedTime)}}</span>
                    <span v-else>不限时</span>
                </div>
                <div v-else>{{EstimatedTime(record.estimatedTime)}}</div>
            </div>
            <div slot="device" slot-scope="text,record">
                <span v-for="item in hardwareList" :key="item.id">
                    {{ (item.id | text.hardwareRequirements) == text.hardwareRequirements ? item.name : ''}}
                </span>
            </div>
            <div slot="status" slot-scope="text,record">
                <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click.native.stop="StatusChange(record)"/>
            </div>
            <div slot="ages" slot-scope="text,record">
                {{record.minAge}} - {{record.maxAge}}
            </div>
            <div slot="action"
                  slot-scope="text, record">
                <a v-if="text.contentType === 4" @click="videoView(text)">预览</a>
                <a v-else @click="look(text)" href="javaScript:;">预览</a>
            </div>
        </a-table>
        <!-- 查看资源 -->
        <a-modal v-model="isView" @cancel="previewModalCancel" title="查看资源" width="50%" destroyOnClose class="ing"
                 :footer="null">
            <div class="prism-player" id="J_prismPlayer"></div>
        </a-modal>
    </a-card>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import {EstimatedTime} from "@/utils/EstimatedTime";

    const columns = [
        {
            title: '内容名称',
            scopedSlots: {customRender: 'name'}
        },
        {
            title: '版本名称',
            scopedSlots: {customRender: 'versionName'}
        },
        {
            title: '内容类型',
            scopedSlots: {customRender: 'contentType'}
        },
        { title: '质量标准', scopedSlots: { customRender: 'classifyTag' }},
        { title: '能力维度', class:'testClass',width:250, key: 'abilityTypeName', scopedSlots: { customRender: 'abilityTypeName' }},
        { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align:'center', key: 'createTime' },
        { title: '用时', scopedSlots: { customRender: 'estimatedTime' }, align:'center', key: 'time'},
        { title: '设备要求', scopedSlots: { customRender: 'device' }, align:'center', key: 'device'},
        {
            title: '操作',
            scopedSlots: {customRender: 'action'},
        },

    ];
    export default {
        name: "courseHourResourceContent",
        data() {
            return {
                EstimatedTime,
                columns,
                tableRelevant: tableRelevant.call(this),
                courseHourResourceInfo: this.$store.getters["organization/getCourseHourResource"],
                base_api: process.env.VUE_APP_API_BASE_URL.slice(7),
                isView: false,
                AliPlayer: null, // 阿里视频播放插件
                //设备
                hardwareList:[
                    {id:1,name:'鼠标'},
                    {id:2,name:'键盘'},
                    {id:4,name:'耳机'},
                    {id:8,name:'麦克风'},
                    {id:16,name:'触屏'},
                    {id:32,name:'陀螺仪'}
                ],
            }
        },
        mounted() {
            this.getContentList();
        },
        methods: {
            videoView(record) {
                this.tabLoading = true
                this.$message.destroy()
                let params = {
                    contentId: record.contentId
                }
                this.$http.Course.GetPlayAuth(params)
                    .then(res => {
                            this.isView = true
                            this.$nextTick(() => {
                                this.AliPlayer = new Aliplayer({
                                        id: 'J_prismPlayer',
                                        width: '100%',
                                        height: '500px',
                                        autoplay: true,
                                        vid: res.data.body.videoMeta.videoId,//播放方式二必选参数。可以通过点播控制台（媒资库>音/视频路径）查询。示例：1e067a2831b641db90d570b6480f****。
                                        playauth: res.data.body.playAuth//播放方式二必选参数。参数值可通过调用GetVideoPlayAuth接口获取。
                                    }, function (player) {
                                        console.log('The player is created.')
                                    }
                                )
                            })
                       
                    })
                    .finally(() => {
                        this.tabLoading = false
                    })
            },
            // 预览弹框关闭回调
            previewModalCancel() {
                if (this.AliPlayer) {
                    this.AliPlayer.pause()
                    this.AliPlayer.dispose()
                    this.AliPlayer = null
                }
            },
            getContentList(pageIndex) {
                const params = {
                    courseSessionId: this.$route.query.id,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize
                };
                this.tableRelevant.tableLoading = true;
                this.$http.CourseResource.contentList(params).then(({ data }) => {
                  this.tableRelevant.tableDataSource = data;
                  this.tableRelevant.tablePagination.total = data.length;
                  this.tableRelevant.tablePagination.current = 1;
                }).finally(() => {
                  this.tableRelevant.tableLoading = false;
                })
            },
            look(val) {
                this.$message.destroy();
                if (!val.uri) {
                    this.$message.error("预览失败！");
                    return
                }
                let url = val.uri;
                switch (val.contentType) {
                    case 2:
                        url = `${val.uri}?url=${this.base_api}&userid=63b44c73-a040-4c06-bb20-752614fc098b&userName=%E5%B0%8F%E5%A4%8F2&firstplay=1&sendStartFlag=true&stage=1&contentId=
            ${val.contentId}&maxStage=${val.maxStage || 30}`;
                        break;
                    case 3:
                        url = val.uri + "?url="
                            + this.base_api + "&questionGroupId="
                            + val.contentId;
                        break;
                }
                window.open(url)
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .ant-table-tbody .testClass {
        padding: 0 !important;
    }

    .self_td {
        height: 54px;
        display: flex;
        align-items: center;
        padding: 0 16px;
    }
</style>
